<template>
    <grid
        :isAutoHeight="true"
        :row-data="rowData"
        :is-search="false"
        :column-defs="columnDefs"
        grid-theme="ag-theme-alpine-compact"
        class="table-header-highlight"
    >
    </grid>
</template>

<script>
import grid from '../../../generic/grid/grid.vue';

export default {
    components: { grid },
    name: 'DamageClaimsAccountHistoryTable',
    data() {
        return {
            values: [],
        };
    },
    props: {
        rowData: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        columnDefs() {
            return [
                {
                    headerName: 'Properties',
                    headerClass: 'centered-header',
                    sortable: false,

                    children: [
                        {
                            field: 'n_properties',
                            headerName: '',
                            minWidth: 120,
                        },
                    ],
                },
                {
                    headerName: 'Rev Share %',
                    headerClass: 'centered-header',
                    sortable: false,
                    children: [
                        {
                            field: '',
                            headerName: 'SDW1500',
                            minWidth: 120,
                            sortable: false,

                            cellRenderer: ({ data }) =>
                                data &&
                                data.discounts.length &&
                                data.discounts[0],
                        },
                        {
                            field: '',
                            headerName: 'SDW3000',
                            minWidth: 120,
                            sortable: false,

                            cellRenderer: ({ data }) =>
                                data &&
                                data.discounts.length &&
                                data.discounts[1],
                        },
                    ],
                },
                {
                    headerName: '# Invoices',
                    headerClass: 'centered-header',
                    sortable: false,

                    children: [
                        {
                            field: 'n_paid_invoices_12',
                            headerName: '12 Mths',
                            cellClass: 'd-flex justify-content-end',
                            headerClass: 'ag-right-aligned-header',
                            sortable: false,
                            minWidth: 120,
                        },
                        {
                            field: 'n_paid_invoices',
                            headerName: 'All-Time',
                            cellClass: 'd-flex justify-content-end',
                            sortable: false,
                            headerClass: 'ag-right-aligned-header',
                            minWidth: 120,
                        },
                    ],
                },
                {
                    headerName: '# Invoices w/DP',
                    headerClass: 'centered-header',
                    sortable: false,
                    children: [
                        {
                            field: 'n_paid_invoices_wd_12',
                            headerName: '12 Mths',
                            cellClass: 'd-flex justify-content-end',
                            headerClass: 'ag-right-aligned-header',
                            sortable: false,
                            minWidth: 120,
                        },
                        {
                            field: 'n_paid_invoices_wd',
                            headerName: 'All-Time',
                            cellClass: 'd-flex justify-content-end',
                            headerClass: 'ag-right-aligned-header',
                            sortable: false,
                            minWidth: 120,
                        },
                    ],
                },
                {
                    headerName: 'Revenue',
                    headerClass: 'centered-header',
                    sortable: false,
                    children: [
                        {
                            field: 'revenue_12',
                            headerName: '12 Mths',
                            type: 'amountColumn',
                            sortable: false,
                            minWidth: 120,
                        },
                        {
                            field: 'revenue',
                            headerName: 'All-Time',
                            type: 'amountColumn',
                            sortable: false,
                            minWidth: 120,
                        },
                    ],
                },
                {
                    headerName: 'Reimbursements',
                    headerClass: 'centered-header',
                    sortable: false,

                    children: [
                        {
                            field: 'reimbursements_12',
                            headerName: '12 Mths',
                            type: 'amountColumn',
                            sortable: false,
                            minWidth: 120,
                        },
                        {
                            field: 'reimbursements',
                            headerName: 'All-Time',
                            type: 'amountColumn',
                            sortable: false,
                            minWidth: 120,
                        },
                    ],
                },
                {
                    headerName: 'Profit / Loss',
                    headerClass: 'centered-header',
                    sortable: false,

                    children: [
                        {
                            field: 'profit_loss_12',
                            headerName: '12 Mths',
                            type: 'amountColumn',
                            sortable: false,
                            minWidth: 120,
                        },
                        {
                            field: 'profit_loss',
                            headerName: 'All-Time',
                            type: 'amountColumn',
                            sortable: false,
                            minWidth: 120,
                        },
                    ],
                },
            ];
        },
    },
};
</script>
<style scoped lang="scss">
:deep(.centered-header) {
    .ag-header-group-cell-label {
        display: flex !important;
        justify-content: center !important;
        text-align: center !important;
        font-size: 15px !important;
    }
}
</style>
